import { gql } from '@fdc/__generated__/gql';

export const REMOVE_FAVOURITE_RECIPE = gql(/* GraphQL */ `
  mutation RemoveFavouriteRecipe($input: RemoveFavouriteRecipeInput!) {
    removeFavouriteRecipe(input: $input) {
      recipeId
      success
      errors {
        message
      }
    }
  }
`);
